import { render, staticRenderFns } from "./BillingReceipt.vue?vue&type=template&id=5954b68e"
import script from "./BillingReceipt.vue?vue&type=script&lang=js"
export * from "./BillingReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports